import { getTeamLogoUrlByTeamId, getTruthyValue, getLogoUrl } from "@draftkings/sportsbook-common-utils";
import { getCountryFlagByCountryId } from "../../helpers";
export function getTeamIconUrl(options) {
    var _a, _b, _c;
    const isSwooshEnabled = options.swooshFeatureFlag;
    const isNationalTeam = options.isNationalTeam;
    if (isSwooshEnabled) {
        const rosettaTeamId = options.rosettaTeamId;
        if (isNationalTeam) {
            return getTruthyValue((_a = getCountryFlagByCountryId(options.swooshBaseUrl, options.countryCode, { size: "sm" })) === null || _a === void 0 ? void 0 : _a.toString(), "");
        }
        if (rosettaTeamId) {
            return getTruthyValue((_b = getTeamLogoUrlByTeamId(options.swooshBaseUrl, rosettaTeamId, { size: "sm" })) === null || _b === void 0 ? void 0 : _b.toString(), "");
        }
    }
    return getTruthyValue(getLogoUrl(options.staticS3Host, (_c = options.teamLogos[options.leagueId]) === null || _c === void 0 ? void 0 : _c.Teams, options.teamName), "");
}
//# sourceMappingURL=getTeamIconUrl.js.map